import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=b4c5be90&scoped=true&"
import script from "./editArticle.vue?vue&type=script&lang=js&"
export * from "./editArticle.vue?vue&type=script&lang=js&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=b4c5be90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5be90",
  null
  
)

export default component.exports